import { answerBluffWsUrl } from "./answerBluffWsUrl";

/** Same host resolution as Answer Bluff; optional JWT for vote/auth on public games. */
export function imposterOnlineWsUrl(websocketPath: string, accessToken?: string | null): string {
  const base = answerBluffWsUrl(websocketPath);
  const tok = (accessToken || "").trim();
  if (!tok) return base;
  const u = new URL(base);
  u.searchParams.set("access", tok);
  return u.toString();
}

/**
 * Guest join URL (no login). Same-origin as the SPA; `code` is the room code (e.g. AB12CD).
 * WebSocket path is always `/ws/imposter/<code>/` on the API host.
 */
export function buildImposterOnlineJoinUrl(roomCode: string): string {
  const origin = typeof window !== "undefined" && window.location?.origin ? window.location.origin : "";
  const code = (roomCode || "").trim().toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8);
  const u = new URL(`${origin}/party/join/imposter`);
  u.searchParams.set("code", code);
  return u.toString();
}
